import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigService } from 'app/services/config/config.service';
import { environment } from 'environments/environment';
import { LanguageService } from 'app/services/language/language.service';
import { LandingPageDataService } from 'app/pages/landing-page/landing-page-data.service';
import { isSupportedLanguage } from 'app/services/language/languages';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {
    now : Date = new Date();
    env = environment;
    get landingEnabled(): boolean { return this.configService.settings?.visibilityControl?.landingPageEnabled === true; }
    get homePath(): string { return this.language.path(this.landingEnabled ? '' : 'locker-locations'); }

    
    constructor(
        public configService: ConfigService,
        public language: LanguageService,
        public landingPageData: LandingPageDataService,
        private router: Router,
        private destroyRef: DestroyRef,
        @Inject(PLATFORM_ID) private platformId: object,
    ) { }

    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) return;
        if (this.landingPageData.currentConfig()) return;

        // La landing carga esta configuración al entrar; las demás páginas la necesitan para las redes sociales.
        const segments = this.router.url.split(/[?#]/, 1)[0].split('/').filter(Boolean);
        if (segments.length === 1 && isSupportedLanguage(segments[0])) return;

        this.landingPageData.load(this.language.currentLang)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({ error: () => {} });
    }
}
